import { cn } from '@/utils/cn'

interface RoundImageProps {
  src: string
  fallback?: string
  className?: string
  alt?: string
}

export const RoundImage = ({ src, fallback, alt, className }: RoundImageProps) => {
  return (
    <object
      data={src}
      type="image/png"
      className={cn('block size-5 shrink-0 overflow-hidden rounded-full bg-surface p-0.5', className)}
    >
      <img src={fallback ?? src} alt={alt} className="block size-full" />
    </object>
  )
}
